var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from '@web/components/ui/Form/Select';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
export var MeetingType;
(function (MeetingType) {
    MeetingType["SCHEDULED"] = "SCHEDULED";
    MeetingType["NON_SCHEDULED"] = "NON_SCHEDULED";
    MeetingType["RECURRING"] = "RECURRING";
    MeetingType["ONE_TIME"] = "ONE_TIME";
})(MeetingType || (MeetingType = {}));
export function MeetingTypeFilter(_a) {
    var _b;
    var _c = _a.isDisplayLabel, isDisplayLabel = _c === void 0 ? true : _c;
    var navigateTo = useNavigateTo();
    var location = useLocation();
    var t = useTranslation().t;
    var meetingType = useFilters().meetingType;
    var options = __spreadArray([
        {
            id: null,
            name: t('filters.all'),
            isAll: true
        }
    ], Object.values(MeetingType).map(function (type) { return ({
        id: type,
        name: t("filters.meetingType.".concat(type))
    }); }), true);
    var selectedMeetingType = (_b = options.find(function (option) { return option.id === meetingType; })) !== null && _b !== void 0 ? _b : options[0];
    var onChange = function (meetingType) {
        navigateTo({
            pathname: location.pathname,
            newFilters: {
                meetingType: meetingType.id
            }
        });
    };
    return (_jsx(Select, { isDisplayLabel: isDisplayLabel, selected: selectedMeetingType, options: options, onChange: onChange, placeholder: t('filters.selectMeetingType'), className: "w-full" }));
}
